import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLabels, usePrefs } from 'wsm-common-data';
import { ErrorBoundary } from 'wsm-error-boundary';
import { EvModal } from 'wsm-common-modal';
import { addNewRelicPageAction } from 'ddc-new-relic';
import QuickSpecs from '../components/QuickSpecs';
import WindowSticker from '../components/WindowSticker';
import AltHeading from '../components/AlternativeHeading/AltHeading';

const Widget = () => {
	const {
		quickSpecs,
		requestData: { deviceType },
		isElectric
	} = useSelector((state) => state);
	const [modalTitle, setModalTitle] = useState('');
	const [modalContent, setModalContent] = useState({});
	const [isOpenModal, setOpenModal] = useState(false);
	const [isMutilEvGroups, setMutilEvGroups] = useState(false);
	const labels = useLabels();

	const { showWindowSticker, enableVinStockInHeading } = usePrefs();

	if (!quickSpecs) {
		addNewRelicPageAction('ws-quick-specs-render-failure', {
			quickSpecs: 'undefined'
		});
		return null;
	}

	const openQuickSpecModal = (
		modalTitleMarkup = '',
		modalContentMarkup = {},
		isMutilFacetGroupsMarkup = false
	) => {
		setOpenModal(true);
		setModalTitle(modalTitleMarkup);
		setModalContent(modalContentMarkup);
		setMutilEvGroups(isMutilFacetGroupsMarkup);
	};

	const closeModal = () => {
		setOpenModal(false);
	};

	const getEvModalOptions = () => {
		return {
			isOpen: isOpenModal,
			onClose: closeModal,
			onOpen: openQuickSpecModal,
			title: modalTitle,
			children: modalContent,
			isMutilFacetGroups: isMutilEvGroups
		};
	};
	const options = getEvModalOptions();

	// vin and stock will appear in alternate heading if pref is enabled
	const showAltHeading = enableVinStockInHeading === 'true';
	const altQuickSpecs = showAltHeading
		? { ...quickSpecs, vin: null, stockNumber: null }
		: null;

	return (
		<ErrorBoundary newRelicPageAction="WS QUICK SPECS ERROR BOUNDARY">
			{showAltHeading && (
				<AltHeading quickSpecs={quickSpecs} deviceType={deviceType} />
			)}
			<EvModal {...options} />
			<QuickSpecs
				quickSpecs={altQuickSpecs || quickSpecs}
				deviceType={deviceType}
				isElectric={isElectric}
				labels={labels}
				onOpenModal={openQuickSpecModal}
			/>
			{enableVinStockInHeading === 'false' &&
				showWindowSticker === 'true' && <WindowSticker />}
		</ErrorBoundary>
	);
};

export default Widget;
